import { render, staticRenderFns } from "./Sistema.vue?vue&type=template&id=48ddb0ca&scoped=true"
import script from "./Sistema.vue?vue&type=script&lang=js"
export * from "./Sistema.vue?vue&type=script&lang=js"
import style0 from "./Sistema.vue?vue&type=style&index=0&id=48ddb0ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ddb0ca",
  null
  
)

export default component.exports